import { useStaticQuery, graphql } from 'gatsby'

export const useVideoCarouselQuery = () => {
const { wpPage } = useStaticQuery(
    graphql`
  query VideoCarouselQuery{
    wpPage(slug: {eq: "home"}) {
      home {
        videoCarouselTitle
        videoCarouselSubtitle
        videoCarouselH1
        videoCarouselVideos {
          videoImage {
            localFile {
              childImageSharp {
                gatsbyImageData(formats: [AUTO, WEBP, AVIF])
              }
            }
          }
          videoImageAltText
          videoLink {
            url
          }
        }
        videoCarouselQuote
        videoCarouselReasons {
          videoCarouselReasonsImage {
            localFile {
              publicURL
            }
          }
          videoCarouselReasonsReason
        }
      }
    }
  }
  `
);
return wpPage.home;
}